<template>
    <div class="full-width-card">
        <div v-if="null == list || list.length === 0">
            <el-empty :description="i18n.tkey('lang_temporary_no_data')">

            </el-empty>
        </div>

        <el-row :gutter="15" v-if="null != list && list.length > 0">
            <el-col
                :span="cols"
                v-for="(v, i) in list"
                :key="v.id"
                style="margin-bottom: 15px"
            >
                <CreatedMallRecord
                    :obj="v"
                    @clickEdit="clickEdit"
                    @clickView="clickView"
                    @clickGoOrder="clickGoOrderFunc"
                />
            </el-col>
        </el-row>
    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount} from "vue";
import CreatedMallRecord from "@/components/shopopee/mall/createdMallRecord.vue";
import myUtil from "@/util/util";
import SponsorRecord from "@/components/shopopee/hall/sponsorRecord.vue";

const props = defineProps(["list"])
const emits = defineEmits(["clickEdit", "clickView","clickGoOrder"])

const i18n = inject("i18n")
const cols = ref(24)

function clickEdit(obj){
    emits("clickEdit", obj)
}

function clickView(obj){
    emits("clickView", obj)
}


function clickGoOrderFunc(obj){

  emits("clickGoOrder", obj)
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }
})


</script>

<style scoped>

.full-width-card {
    box-sizing: border-box;
    padding: 0 10px;
}

</style>